
import {
  Vue, Component, PropSync, Prop,
} from 'vue-property-decorator';
import { InputValidationRules } from 'vuetify';
import { PaymentInfoResponse } from '@/features/shipment/types';
import { numberRules, requiredRules } from '@/features/common/helpers/validationRules';

@Component
export default class Verification extends Vue {
  @Prop({ required: true }) existingCardInfo!: PaymentInfoResponse | null;

  @PropSync('verificationAmount', { required: true }) amountSync!: string;

  @Prop({ required: true }) attemptsCount!: number;

  private requiredRules = requiredRules;

  private numberRules = numberRules;

  private getVerificationAmountRules(): InputValidationRules {
    return [
      ...this.requiredRules,
      ...this.numberRules,
      (v: string): string | boolean => {
        return this.isLessThanVerificationAmount(v) || this.$t('labels.maxVerificationAmount') as string;
      },
    ];
  }

  private isLessThanVerificationAmount = (value: string): boolean => {
    const val = parseFloat(value);
    return val <= 5;
  }
}
